import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [{
    path: '/',
    redirect: '/home'
}, {
    path: "/",
    component: () => import("@/views/website"),
    children: [{
        path: '/home',
        name: 'home',
        component: () => import('@/views/home')
    }, {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about')
    }, {
        path: '/consult',
        name: 'consult',
        component: () => import('@/views/consult')
    }, {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news')
    }, {
        path: '/news/detail',
        name: 'newsDetail',
        component: () => import('@/views/news/detail.vue')
    }, {
        path: '/paper',
        name: 'paper',
        component: () => import('@/views/paper')
    }, {
        path: '/research',
        name: 'research',
        component: () => import('@/views/research')
    }, {
        path: '/solution',
        name: 'solution',
        component: () => import('@/views/solution')
    },{
        path: '/search',
        name: 'search',
        component: () => import('@/views/search')
    },]
}]

const router = new Router({
    mode: 'history',
    base: "/",
    routes,
})

export default router